export const RUTAS = {
    ROOT: '/',
    LOGIN: 'login',
    HOME: 'home',
    VOLQUETES: 'volquetes',
    PEDIDOS: 'pedidos'
} as const
